<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #eb401f;
}

input:focus + .slider {
  box-shadow: 0 0 1px #eb401f;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
<template>
  <div>
    <template v-if="update_EP_pool_balance === true ">
      <div class="page-top mb-1 mb-3 clearfix">
        <h1 class="float-left"> Easy Paisa Pool Account Update </h1>
      </div>
      <div class="global-main">
        <div class="people-management-inner-content">
          <form @submit.prevent="insertAmount()" id="insertAmount">
            <div class="tab-content-inner">
              <div class="user-permissions">
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label class="label block-label"> Current Easy Paisa Pool Account Balance: <em class="required">*</em></label>
                      <p><strong>RS&nbsp{{new Intl.NumberFormat().format(data.runningBalance)}}</strong></p>
                    </div>
                    <div class="col">
                      <label class="label block-label">Rails Status:</label>
                      <div class="col">
                        <div class="row">
                          <h3 class="col-1">OFF</h3>
                          <label class="switch col-1">
<!--                            <input type="checkbox"  :checked="data.status == 'ON'? true : false" v-model="checkbox" v-on:click="poolAccountToggle">-->
                            <input type="checkbox"   v-model="checkbox" v-on:click="poolAccountToggle">
                            <span class="slider round"></span>
                          </label>
                          <h3 class="col-1">ON</h3>
                        </div>
                      </div>

<!--                        <p><strong>{{data.status}}</strong></p>-->
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="label block-label">Consumed Daily Limit for <strong>{{data.dailyConsumedLimitDate}}</strong>:</label>
                  <p><strong>RS&nbsp{{new Intl.NumberFormat().format(data.dailyConsumedLimit)}}</strong></p>
                </div>
                <div class="form-group">
                  <h1>Update Current Balance</h1>
                </div>
                <div class="form-group">
                  <label class="label block-label required"> Amount <small>(*current balance after topup)</small></label>
                  <input v-model="form.amount" type="number" name="amount" class="form-control"
                         :class="{ 'is-invalid': form.errors.has('amount') }" autocomplete="off">
                  <has-error :form="form" field="amount"></has-error>
                </div>
                <div class="page-top mb-1 mb-3 clearfix" v-if="update_EP_pool_balance == true">
                  <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                  <router-link to="/" class="btn btn-primary float-right mr-1"> Cancel</router-link>
                </div>
              </div>

            </div>

          </form>
        </div>
      </div>
    </template>
    <template v-else-if="update_EP_pool_balance === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="update_EP_pool_balance === false">
      <notAllowed></notAllowed>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      checkbox:'',
      data:[],
      update_EP_pool_balance:'',
      form: new Form({
        amount: '',
      }),

    }
  },
  methods: {
    insertAmount() {
      if (!this.form.amount > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No Amount was entered!',
        })
        this.$Progress.finish();
      }else {
        Swal.fire({
          title: 'Are you sure?',
          text: 'Rs. ' + this.form.amount + ' will be updated as Easy Paisa Pool Account current running balance!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Update Now'
        }).then((result) => {
          if (result.value) {
            this.$Progress.start();
            this.form.post('/api/epPoolBalanceUpdate')
                .then(res => {
                  let responseData = res.data;
                  if (responseData.code == 200) {
                    this.showToastBox('success', 'Pool Account Balance Updated');
                    this.getEPPoolAccountData();
                    // this.$router.go(this.$router.currentRoute);
                    this.$Progress.finish();
                  } else {
                    this.$Progress.fail();
                    this.showAlertBox('error', 'Connection Error!');
                  }
                })
                .catch(err => {
                  this.$Progress.fail();
                  this.showAlertBox('error', 'Some problem in your form data');
                });
          }
        })
      }

    },
    getEPPoolAccountData() {
      this.$Progress.start();
      axios.get('/api/getEPPoolAccountData')
          .then(res => {
            if (res.status == 200) {
              this.data = res.data;
              if (res.data.status == 'ON'){
                this.checkbox = true;
              }else{
                this.checkbox = false;
              }
              this.$Progress.finish();
            } else {
              this.$Progress.fail();
              this.showAlertBox('error', 'Some error occured while loading this page');
            }
          })
          .catch(err => {
            this.showAlertBox('error', 'Connection Failure');
          });
    },
    poolAccountToggle(){
      let that = this;
      this.$Progress.start();
      if (this.data.status == 'ON') {
        Swal.fire({
          title: 'Are you sure?',
          text: 'Easy Paisa rails will be swithched OFF!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Switch Off'
        }).then((result) => {
          if (result.value) {
            axios.get("/api/easyPaisaToggle")
                .then(res => {
                  if (res.status == 200) {
                    this.getEPPoolAccountData();
                  } else {
                    this.$Progress.fail();
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                    })
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.$Progress.fail();
                  this.showAlertBox('error', 'request could not be processed');
                  this.checkbox = true;
                });

          }else{this.$router.go(this.$router.currentRoute);}

        })
      }
      if (this.data.status == 'OFF') {
        Swal.fire({
          title: 'Are you sure?',
          text: 'EasyPaisa rails will be swithched ON!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Switch ON'
        }).then((result) => {
          if (result.value) {
            axios.get("/api/easyPaisaToggle")
                .then(res => {
                  if (res.status == 200) {
                    this.getEPPoolAccountData();
                  } else {
                    this.$Progress.fail();
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                    })
                  }
                })
                .catch(err => {
                  console.log(err);
                  this.$Progress.fail();
                  this.showAlertBox('error', 'request could not be processed. You Might not have suffecient permissions to run this process! ');
                  this.checkbox = false;
                });

          }else{
            this.$router.go(this.$router.currentRoute);
          }
        })
      }
    },
  },
  mounted() {
    this.$Progress.start();
    this.can('update_EP_pool_balance').then(result => {
      this.update_EP_pool_balance = result.update_EP_pool_balance;
    }).then(result => {
      if (this.update_EP_pool_balance == true) {
        this.getEPPoolAccountData();
        this.$Progress.finish();
      } else {
        this.$Progress.finish();
      }
    });
  }
}
</script>
